import { server } from '../constants';
import { httpClient } from './../utils/HttpClient';

// lssue-log data model

/**
 * getList() get list issueLog
 * @param {object} params
 * @param {object} params.package base64 of props {lang, issue_id, mode, orderAsc }
 * @return
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/IssueLog
 */
export function getList(params) {
  return httpClient
    .get(`${server.ISSUE_LOG_URL}/getList`, { params })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
